module.exports = require('./lib/codemirror');
